/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DefaultVipDiscountPostDto } from '../../models/default-vip-discount-post-dto';
import { DefaultVipDiscountResponseModel } from '../../models/default-vip-discount-response-model';

export interface CreateDefaultVipDiscounts$Params {
      body: DefaultVipDiscountPostDto
}

export function createDefaultVipDiscounts(http: HttpClient, rootUrl: string, params: CreateDefaultVipDiscounts$Params, context?: HttpContext): Observable<StrictHttpResponse<DefaultVipDiscountResponseModel>> {
  const rb = new RequestBuilder(rootUrl, createDefaultVipDiscounts.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DefaultVipDiscountResponseModel>;
    })
  );
}

createDefaultVipDiscounts.PATH = '/discounts/vip/defaults';
